import React from 'react';

const TEMPLATES = [
    {
        name: 'Web Server',
        icon: '\uD83C\uDF10',
        description: 'Registro A para o dominio raiz e CNAME www apontando para o raiz.',
        records: (zoneName) => [
            { type: 'A', name: zoneName, content: '', ttl: 1, proxied: true },
            { type: 'CNAME', name: `www.${zoneName}`, content: zoneName, ttl: 1, proxied: true },
        ],
    },
    {
        name: 'Mail Setup',
        icon: '\uD83D\uDCE7',
        description: 'Registro MX e TXT com SPF basico para recebimento de e-mails.',
        records: (zoneName) => [
            { type: 'MX', name: zoneName, content: `mail.${zoneName}`, ttl: 3600, priority: 10 },
            { type: 'TXT', name: zoneName, content: 'v=spf1 mx ~all', ttl: 3600 },
        ],
    },
    {
        name: 'Subdomain',
        icon: '\uD83D\uDCC2',
        description: 'Registro A para um subdominio personalizado.',
        records: (zoneName) => [
            { type: 'A', name: `sub.${zoneName}`, content: '', ttl: 1, proxied: true },
        ],
    },
    {
        name: 'Google Workspace',
        icon: '\uD83D\uDCE8',
        description: 'Registros MX do Google Workspace para e-mail corporativo.',
        records: (zoneName) => [
            { type: 'MX', name: zoneName, content: 'aspmx.l.google.com', ttl: 3600, priority: 1 },
            { type: 'MX', name: zoneName, content: 'alt1.aspmx.l.google.com', ttl: 3600, priority: 5 },
            { type: 'MX', name: zoneName, content: 'alt2.aspmx.l.google.com', ttl: 3600, priority: 5 },
            { type: 'MX', name: zoneName, content: 'alt3.aspmx.l.google.com', ttl: 3600, priority: 10 },
            { type: 'MX', name: zoneName, content: 'alt4.aspmx.l.google.com', ttl: 3600, priority: 10 },
        ],
    },
    {
        name: 'Microsoft 365',
        icon: '\uD83D\uDCE9',
        description: 'Registro MX e CNAME autodiscover para Microsoft 365.',
        records: (zoneName) => {
            const domainPrefix = zoneName.replace(/\./g, '-');
            return [
                { type: 'MX', name: zoneName, content: `${domainPrefix}.mail.protection.outlook.com`, ttl: 3600, priority: 0 },
                { type: 'CNAME', name: `autodiscover.${zoneName}`, content: 'autodiscover.outlook.com', ttl: 3600 },
            ];
        },
    },
];

const RecordTemplates = ({ zoneName, onSelectTemplate, onClose }) => {
    const handleSelect = (template) => {
        const resolvedRecords = template.records(zoneName);
        onSelectTemplate({
            name: template.name,
            records: resolvedRecords,
        });
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
                <div className="modal-header">
                    <h2 className="modal-title">Templates de Registros</h2>
                    <button className="close-btn" onClick={onClose}>{'\u00D7'}</button>
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '16px',
                    padding: '20px',
                }}>
                    {TEMPLATES.map(template => {
                        const previewRecords = template.records(zoneName);
                        return (
                            <div
                                className="template-card"
                                key={template.name}
                                style={{
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    backgroundColor: '#fff',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ fontSize: '24px' }}>{template.icon}</span>
                                    <span style={{ fontWeight: 600, fontSize: '15px' }}>{template.name}</span>
                                </div>
                                <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
                                    {template.description}
                                </p>
                                <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>
                                    {previewRecords.map((r, i) => (
                                        <div key={i}>
                                            {r.type} {r.name} {'\u2192'} {r.content || '(definir IP)'}
                                            {r.priority !== undefined ? ` (pri: ${r.priority})` : ''}
                                        </div>
                                    ))}
                                </div>
                                <button
                                    className="btn btn-primary"
                                    style={{ marginTop: 'auto', padding: '6px 12px', fontSize: '13px' }}
                                    onClick={() => handleSelect(template)}
                                >
                                    Usar Template
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RecordTemplates;
